module.exports = __webpack_public_path__ + "static/media/superdry.5ed2946b.svg";